import {
    Button,
    Container,
    Divider,
    Grid,
    Icon,
    Pagination,
    Stack,
} from "@mui/material";
import * as React from "react";
import { ProjectSearchType } from "../../../../api/psc";
import {
    EmptyListMessage,
    EndOfInfiniteListMessage,
} from "../../../../components/exports";
import PageWithFilter from "../../../../components/shared/PageWithFilter";
import { defaultLimit } from "../../../../constants/GlobalConstants";
import DesktopProjectToolbox from "../../components/DesktopProjectToolbox";
import MobileProjectToolbox from "../../components/MobileProjectToolbox";
import ProjectItem from "../../components/ProjectItem";
import ProjectsFilter from "../../components/ProjectsFilter";
import { ProjectState } from "../../slice/ProjectSlice";

type TProps = {
    isSmallOrDownScreen: boolean;
    fetch: () => void;
    onProjectTypeChange: (type: ProjectSearchType) => void;
    projectState: ProjectState;
    handlePageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
    openGoToPage: () => void;
};

export default function ProjectsView({
    fetch,
    handlePageChange,
    isSmallOrDownScreen,
    onProjectTypeChange,
    openGoToPage,
    projectState,
}: TProps) {
    return (
        <Container maxWidth={false} sx={{ maxWidth: 2000 }}>
            <PageWithFilter filter={<ProjectsFilter />}>
                {isSmallOrDownScreen ? (
                    <MobileProjectToolbox
                        fetchProjects={fetch}
                        setProjectType={onProjectTypeChange}
                        isRequirements={false}
                        filterElement={<ProjectsFilter />}
                        state={projectState}
                    />
                ) : (
                    <DesktopProjectToolbox
                        state={projectState}
                        isRequirements={false}
                        fetchProjects={fetch}
                        setProjectType={onProjectTypeChange}
                    />
                )}

                {!projectState.isLoading &&
                    projectState.projects.length === 0 && (
                        <EmptyListMessage message="پروژه ای یافت نشد" />
                    )}

                {projectState.projects.length > 0 && (
                    <>
                        <Grid container spacing={2.5}>
                            {projectState.projects.map((p, i) => {
                                return (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        lg={4}
                                        xl={3}
                                        key={p.hashId}
                                    >
                                        <ProjectItem
                                            index={i}
                                            isLoading={projectState.isLoading}
                                            project={p}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>

                        <Divider sx={{ mt: 2, mb: 2 }} />

                        {projectState.totalCount > defaultLimit ? (
                            <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Pagination
                                    count={Math.ceil(
                                        projectState.totalCount / defaultLimit
                                    )}
                                    color="primary"
                                    page={projectState.page + 1}
                                    onChange={handlePageChange}
                                />
                                <Button
                                    variant="outlined"
                                    onClick={openGoToPage}
                                    startIcon={<Icon>pageview</Icon>}
                                    size="small"
                                >
                                    برو به صفحه
                                </Button>
                            </Stack>
                        ) : (
                            <EndOfInfiniteListMessage />
                        )}
                    </>
                )}
            </PageWithFilter>
        </Container>
    );
}
